"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TeamsIntegrationModalFileListStep = require("./TeamsIntegrationModalFileListStep");
Object.keys(_TeamsIntegrationModalFileListStep).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TeamsIntegrationModalFileListStep[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TeamsIntegrationModalFileListStep[key];
    }
  });
});